import { useState, useEffect, useRef } from 'react';
import { FORM_ACTION_STATUS, } from '../types';
import { generateUUID } from '@wix/form-schema';
export const useFormActions = ({ wfActions, wfResults, }) => {
    const [formActions, setFormActions] = useState({});
    const [inProgress, setInProgress] = useState(false);
    const unresolvedActions = useRef(new Map());
    useEffect(() => {
        if (!wfResults) {
            return;
        }
        unresolvedActions.current.forEach((promiseHandler, actionId) => {
            if (!wfResults[actionId] ||
                wfResults[actionId].status === FORM_ACTION_STATUS.PENDING) {
                setInProgress(true);
                return;
            }
            if (wfResults[actionId].status === FORM_ACTION_STATUS.FAILURE) {
                promiseHandler.reject(wfResults[actionId].result);
            }
            if (wfResults[actionId].status === FORM_ACTION_STATUS.SUCCESS) {
                promiseHandler.resolve(wfResults[actionId].result);
            }
            unresolvedActions.current.delete(actionId);
            setInProgress(unresolvedActions.current.size > 0);
        });
    }, [wfResults]);
    useEffect(() => {
        if (!wfActions) {
            return;
        }
        const actions = Object.entries(wfActions).reduce((acc, [actionName, actionFunction]) => {
            acc[actionName] = (...args) => {
                const correlationId = generateUUID();
                actionFunction(correlationId, ...args);
                return new Promise((resolve, reject) => {
                    unresolvedActions.current.set(correlationId, { resolve, reject });
                });
            };
            return acc;
        }, {});
        setFormActions(actions);
    }, [wfActions]);
    return {
        formActions,
        inProgress,
    };
};
//# sourceMappingURL=use-form-actions.js.map